export default "__VITE_ASSET__b47f3e40__"